import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './controls.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SMLSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel: string;
  disabled?: boolean;
  testId?: string;
}

/** An on/off switch (design d0: "On or off: switch"). */
const SMLSwitchComponent: React.FC<SMLSwitchProps> = ({ checked, onChange, ariaLabel, disabled = false, testId }) => {
  const toggle = useCallback(() => onChange(!checked), [checked, onChange]);
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      className={clsx(styles.switch, checked && styles.switchOn)}
      onClick={toggle}
      disabled={disabled}
      data-testid={testId}
    />
  );
};

export const SMLSwitch = TypedMemo(SMLSwitchComponent);
